<template>
  <modal :show="open" @update:show="on_close" size="lg" class="col-12">
    <template slot="header">
      <h5 class="modal-title" id="exampleModalLabel">
        Criação de suporte
      </h5>
    </template>

    <form>
      <div class="row">
        <div class="col-md-6">
          <label class="form-control-label d-block mb-3">Nome Completo</label>
          <base-input
            class="mb-3"
            v-model="FORM.support_claimant.name"
            placeholder="Nome completo"
          ></base-input>
        </div>
        <div class="col-md-6">
          <label class="form-control-label d-block mb-3">E-mail</label>
          <base-input
            class="mb-3"
            v-model="FORM.support_claimant.email"
            placeholder="Email"
          ></base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="form-control-label d-block mb-3">Localização</label>
          <base-input
            class="mb-3"
            v-model="FORM.support_claimant.location"
            :disabled="true"
          ></base-input>
        </div>
        <div class="col-md-6">
          <label class="form-control-label d-block mb-3"
            >Número para contato</label
          >
          <base-input
            class="mb-3"
            v-model="FORM.support_claimant.phone"
            :mask="backspacePressedPhone ? null : 'phone'"
            placeholder="Telefone"
            @keydown.backspace="onPhoneKeydown"
            @keyup="handleOnKeyUp"
          ></base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <full-description 
            ref="fullDescriptionRef" 
            label="Descrição"
            limitMessage="Você pode anexar no máximo 5 imagens."
          />
        </div>
      </div>
    </form>
    <template slot="footer">
      <base-button type="secondary" @click="on_close">Fechar</base-button>
      <base-button type="success" @click="ON_SUBMIT">Salvar</base-button>
    </template>
  </modal>
</template>

<script>
import { ref, onMounted, getCurrentInstance } from "vue";
import AxiosInstance from "../../../backend/axios";
import FileList from "@/components/FileList";
import FullDescription from "../../../components/FullDescription.vue";

export default {
  components: {
    FileList,
    FullDescription
  },
  props: {
    open: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data: function () {
    return {
      route: this.$route,
      toasted: this.$toasted,
      backspacePressedPhone: false,
      media: [],
    };
  },
  methods: {
    onPhoneKeydown(e) {
      if (e.keyCode === 8) {
        return this.backspacePressedPhone = true;
      }
    },
    handleOnKeyUp(e) {
      if (e.keyCode != 8) this.backspacePressedPhone = false;
    }
  },
  setup(props, { emit }) {
    const APP = getCurrentInstance();
    const toasted = APP.proxy.$toasted;
    const USER = JSON.parse(localStorage.currentUser);
    const VALID_FORM = ref(true);
    const FORM = ref({
      support_claimant: {
        name: null,
        email: null,
        phone: null,
        location: null,
      },
      summary: null,
      description: {},
      media: [],
    });
    const NEW_SUPPORT_FORM = ref(null);
    const RULES = ref({
      required: (v) => !!v || "Campo obrigatório",
    });
    const SUPPORT_JWT =
      process.env && process.env.VUE_APP_SUPPORT_JWT
        ? process.env.VUE_APP_SUPPORT_JWT
        : null;


    const on_close = () => {
      fullDescriptionRef.value.clearEditor()
      FORM.value.support_claimant.phone = null;
      emit("update:open", false);
    }

    const validateForm = () => {
      const fullDescription = fullDescriptionRef.value;
      const description = fullDescription.getDescription();

      return !FORM.value.support_claimant.phone ||
            !FORM.value.support_claimant.name ||
            !FORM.value.support_claimant.email ||
            !FORM.value.support_claimant.location ||
            !description;
    };


    const fullDescriptionRef = ref(null);

    async function ON_SUBMIT() {
      if (validateForm()) {
          toasted.global.defaultError({ msg: 'Por favor, preencha todos os campos' });
        return;
      }

      try {
        var mk = "";
        const fullDescription = fullDescriptionRef.value;
        const summary = fullDescription.getDescription();

        FORM.value.support_claimant.location = window.location.pathname
            .replace("/", "")
            .split("/")[0];

        const mdContent = 
          `**Localização:** ${window.location.href || "Não definido"}
          **Observação:** ${summary || "Não definido"}`
        .trim().replace(/\n\s*/g, "\n\n");

        FORM.value.description = {
          type: "markdown",
          text: mdContent,
        };

        const formData = new FormData();

        formData.append('support_ticket[support_claimant][name]', FORM.value.support_claimant.name);
        formData.append('support_ticket[support_claimant][email]', FORM.value.support_claimant.email);
        formData.append('support_ticket[support_claimant][phone]', FORM.value.support_claimant.phone);
        formData.append('support_ticket[support_claimant][cpf]', FORM.value.support_claimant.cpf);
        formData.append('support_ticket[summary]', summary);
        formData.append('support_ticket[description][type]', FORM.value.description.type);
        formData.append('support_ticket[description][text]', FORM.value.description.text);

        const images = fullDescription.getImages();
        images.forEach((image) => {
          formData.append("support_ticket[media][]", image);
        });

        (FORM.value.media || []).forEach(media => {
          formData.append('support_ticket[media][]', media);
        });

        const RESPONSE = await AxiosInstance.post(
          `https://suporte.spezi.com.br/api/v1/support_tickets?software_jwt=${SUPPORT_JWT}`,
          formData,
        );

        FORM.value.summary = "";
        FORM.value.media = [];
        FORM.value.support_claimant.phone = [];

        if (RESPONSE.data) emit("on:submit", RESPONSE.data);
      } catch (error) {
        console.log(error);
      }

      on_close();
    };

    onMounted(() => {
      FORM.value.support_claimant = {
        name: USER.name || "",
        email: USER.email || "",
        phone: USER.celular || USER.telefone || "",
        cpf: USER.cpf || "",
        location: window.location.pathname.replace("/", "").split("/")[0],
      };
    });

    return {
      NEW_SUPPORT_FORM,
      VALID_FORM,
      FORM,
      on_close,
      ON_SUBMIT,
      RULES,
      fullDescriptionRef
    };
  },
};
</script>
